import { type UnitMappingByIssuerAndIdentifierPayload } from './useQueryUnitMappingByIdentifierAndIssuer';
import { type UnitsSearchParams } from './useQueryUnits';

export const queryKeysUnit = {
  base: () => 'unit' as const,
  getAll: (searchParams: UnitsSearchParams) =>
    [queryKeysUnit.base(), 'list', searchParams] as const,
  getMappingByIssuerAndIdentifier: (
    unitMappingContext: UnitMappingByIssuerAndIdentifierPayload,
  ) =>
    [
      queryKeysUnit.base(),
      'mapping',
      'details',
      'byIssuerAndIdentifier',
      unitMappingContext,
    ] as const,
} as const;
